import * as ActionTypes from './types.action';

export const updateBasketItemQuantityInModal = quantity => ({
  type: ActionTypes.UPDATE_BASKET_ITEM_QUANTITY_SUCCESS,
  quantity
});



// WEBPACK FOOTER //
// ./actions/quantity.action.js